module.exports = __webpack_public_path__ + "media/images/map-235768792ecaaccd3c664f3adfd58d67.png";